import { rootElement, routeList } from "./config/config";
import { adminRootElement, cloudAdminRouteList } from "./config/adminConfig";

import PrivateRouter from './PrivateRouter';

export const getRoutes = () => {
  let resultList = [];
  let privateList = [];
  for (const [key, list] of Object.entries(routeList)) {
    for (const item of list) {
      let tmp = {
        path: item.path,
        loader: item.loader || null
      };
      if (item.publicRouter) {
        tmp.element = item.element;
        resultList.push(tmp);
      } else {
        tmp.element = <PrivateRouter> {item.element} </PrivateRouter>;
        privateList.push(tmp);
      }
    }
  }

  const cloudAdminList = cloudAdminRouteList.reduce((acc, item) => {
    if (Array.isArray(item.path)) {
      item.path.forEach((path) => {
        acc.push({
          path: path,
          element: <PrivateRouter>{item.element}</PrivateRouter>,
          loader: item.loader || null
        });
      })
    } else {
      acc.push(item);
    }
    return acc;
  }, []).map((item) => {
    return {
      path: item.path,
      element: <PrivateRouter>{item.element}</PrivateRouter>,
      loader: item.loader || null
    };
  });
  const adminList = Object.assign({}, adminRootElement, { children: cloudAdminList });
  privateList.push(adminList);
  const mainList = Object.assign({}, rootElement, { children: privateList });

  resultList.push(mainList);
  // console.log(mainList);
  // resultList.push(adminList)
  return resultList;
};
